export default __webpack_public_path__ + "static/porquehojeesabado-5914da7c6a68127e6fde74653dfccb0a.webp";